import { Injectable } from '@angular/core';
/** @deprecated */
export var TooltipOptions = (function () {
    function TooltipOptions(options) {
        Object.assign(this, options);
    }
    TooltipOptions.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    TooltipOptions.ctorParameters = function () { return [
        { type: Object, },
    ]; };
    return TooltipOptions;
}());
//# sourceMappingURL=tooltip-options.class.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/tooltip/tooltip-options.class.js
// module id = 1131
// module chunks = 10